import React, { useEffect, useState, useRef } from 'react';

export default function HorizontalTicker({ value }) {
  const chars = String(value).split('');
  
  return (
    <span style={{ display: 'inline-flex', fontVariantNumeric: 'tabular-nums' }}>
      {chars.map((char, i) => (
        <TickerChar key={i} char={char} delay={i * 0.15} />
      ))}
    </span>
  );
}

function TickerChar({ char, delay }) {
  const isDigit = /^[0-9]$/.test(char);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);

  if (!isDigit) {
    return (
      <span ref={ref} style={{ display: 'inline-flex', alignItems: 'center' }}>
        {char}
      </span>
    );
  }

  const targetNum = parseInt(char, 10);
  // To ensure every digit animates, even 0, we create a track that goes up to 0 again at the end.
  const track = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
  const targetIndex = targetNum === 0 ? 10 : targetNum;

  // Percentage to translate based on the total items in the track
  const translatePct = (targetIndex / track.length) * 100;

  return (
    <span 
      ref={ref} 
      style={{ 
        display: 'inline-flex', 
        overflow: 'hidden',
        width: '1ch',
      }}
    >
      <span 
        style={{
          display: 'flex',
          transition: isVisible ? `transform 1.2s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s` : 'none',
          transform: isVisible ? `translateX(-${translatePct}%)` : 'translateX(0%)'
        }}
      >
        {track.map((num, i) => (
          <span 
            key={i} 
            style={{ 
              width: '1ch', 
              flexShrink: 0, 
              display: 'inline-flex',
              justifyContent: 'center'
            }}
          >
            {num}
          </span>
        ))}
      </span>
    </span>
  );
}
